<div class="card text-left">
  <div class="card-header bg-light">
    <h4 class="card-title mb-0">Editar Constatação</h4>
  </div>

  <!-- ✅ REMOVIDO 'wrapper' - só card-body com m-0 -->
  <div class="card-body m-0">
    <form class="needs-validation" novalidate [formGroup]="form">

      <!-- Linha 1: Numeração / Descrição / Status -->
      <div class="row mt-2">
        <div class="col-sm-3">
          <label class="form-label">Numeração da Constatação:</label>
          <input type="text"
                 class="form-control form-control-sm"
                 formControlName="identificador"
                 disabled
                 placeholder="-" />
        </div>

        <div class="col-sm-6">
          <label class="form-label">Descrição da Constatação:</label>
          <input type="text"
                 class="form-control form-control-sm"
                 formControlName="descricaoConstatacao"
                 disabled
                 placeholder="-" />
        </div>

        <div class="col-sm-3">
          <label class="form-label">Status:</label>
          <input type="text"
                 class="form-control form-control-sm"
                 disabled
                 [value]="
                   form.get('status')?.value === 1 ? 'Não iniciada' :
                   form.get('status')?.value === 2 ? 'Em Elaboração' :
                   form.get('status')?.value === 3 ? 'Finalizada' : '-'
                 " />
        </div>
      </div>

      <!-- Situação Encontrada / Riscos Vinculado -->
      <div class="row mt-2">
        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Situação Encontrada</label>
          <textarea class="form-control form-control-sm"
                    rows="5"
                    maxlength="2000"
                    formControlName="situacaoEncontrada"
                    [readonly]="!podeEditar"></textarea>

          <small class="text-muted d-block text-right">
            {{ form.get('situacaoEncontrada')?.value?.length || 0 }} / 2000
          </small>

          <div *ngIf="form.get('situacaoEncontrada')?.invalid && form.get('situacaoEncontrada')?.touched"
               class="text-danger text-xs mt-1">
            Campo obrigatório
          </div>
        </div>

        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Riscos Vinculado</label>
          <textarea class="form-control form-control-sm"
                    rows="5"
                    formControlName="riscoVinculado"
                    disabled></textarea>
        </div>
      </div>

      <!-- Critérios Infringidos / Evidências -->
      <div class="row mt-2">
        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Critérios Infringidos</label>
          <textarea class="form-control form-control-sm"
                    rows="5"
                    formControlName="criteriosInfringidos"
                    disabled></textarea>
        </div>

        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Evidências</label>

          <div class="border rounded p-2 bg-light" style="min-height: 120px;">
            <ng-container *ngIf="evidenciasDetalhadas?.length > 0; else semEvidencias">

              <div *ngFor="let ev of evidenciasDetalhadas" class="d-flex align-items-start mb-1">
        <span class="mr-2">
          <i class="fas fa-paperclip" *ngIf="ev.tipo === 1"></i>
          <i class="fas fa-link" *ngIf="ev.tipo === 2"></i>
          <i class="fas fa-align-left" *ngIf="ev.tipo === 3"></i>
        </span>

                <!-- Tipo 1: Arquivo com download -->
                <span *ngIf="ev.tipo === 1 && ev.arquivoId" class="d-flex flex-column">
          <span *ngIf="ev.nomePapel" class="text-muted d-block" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
          <a href="javascript:void(0)" (click)="download(ev)" class="text-primary">
            {{ ev.nomeArquivo || ev.nomePapel || ev.texto }}
          </a>
        </span>

                <!-- Tipo 1: Arquivo sem download (NomePapelManual) -->
                <span *ngIf="ev.tipo === 1 && !ev.arquivoId" class="d-flex flex-column">
          <span *ngIf="ev.nomePapel" class="text-muted d-block" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
          <span class="text-dark">{{ ev.nomeArquivo || ev.nomePapel || '-' }}</span>
        </span>

                <!-- Tipo 2: Link -->
                <span *ngIf="ev.tipo === 2" class="d-flex flex-column">
          <span *ngIf="ev.nomePapel" class="text-muted d-block" style="font-size: 0.85rem;">{{ ev.nomePapel }}</span>
          <a [href]="extrairUrl(ev.texto)" target="_blank" rel="noopener" class="text-primary">
            {{ extrairTextoSemPrefixo(ev.texto) }}
          </a>
        </span>

                <!-- Tipo 3: Justificativa -->
                <span *ngIf="ev.tipo === 3" class="text-dark">
          <span *ngIf="ev.nomePapel" class="text-muted" style="font-size: 0.85rem;">{{ ev.nomePapel }} - </span>
                  {{ extrairTextoSemPrefixo(ev.texto) }}
        </span>

              </div>

            </ng-container>

            <ng-template #semEvidencias>
              <span class="text-muted">-</span>
            </ng-template>
          </div>

        </div>
      </div>

      <!-- Causas / Efeito -->
      <div class="row mt-2">
        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Causas</label>
          <textarea class="form-control form-control-sm"
                    rows="4"
                    maxlength="200"
                    formControlName="causa"
                    [readonly]="!podeEditar"></textarea>

          <small class="text-muted d-block text-right">
            {{ form.get('causa')?.value?.length || 0 }} / 200
          </small>

          <div *ngIf="form.get('causa')?.invalid && form.get('causa')?.touched"
               class="text-danger text-xs mt-1">
            Campo obrigatório
          </div>
        </div>

        <div class="col-sm-6">
          <label class="form-label fw-bold mb-1">Efeito</label>
          <textarea class="form-control form-control-sm"
                    rows="4"
                    maxlength="200"
                    formControlName="efeito"
                    [readonly]="!podeEditar"></textarea>

          <small class="text-muted d-block text-right">
            {{ form.get('efeito')?.value?.length || 0 }} / 200
          </small>

          <div *ngIf="form.get('efeito')?.invalid && form.get('efeito')?.touched"
               class="text-danger text-xs mt-1">
            Campo obrigatório
          </div>
        </div>
      </div>

      <!-- ===================== RECOMENDAÇÕES ===================== -->
      <div class="row mt-3 recomendacoes-wrapper">
        <div class="col-sm-12">
          <label class="form-label fw-bold mb-1">Recomendações:</label>

          <div class="card card-outline mt-0">
            <div class="card-body p-2">

              <!-- Select + Botões -->
              <div class="row g-2 align-items-end">
                <div class="col-md-12 mb-1">
                  <label class="form-label">Selecionar recomendação:</label>

                  <div class="input-group input-group-sm">
                    <select class="form-control"
                            formControlName="recomendacaoSelecionadaId"
                            [disabled]="!podeEditar"
                            (change)="onChangeRecomendacaoSelecionada($any($event.target).value)">
                      <option [ngValue]="null">Selecione uma Recomendação</option>
                      <option *ngFor="let r of recomendacoesDisponiveis" [ngValue]="r.id">
                        {{ r.titulo || ('Recomendação #' + r.id) }}
                      </option>
                    </select>

                    <div class="input-group-append">
                      <button type="button"
                              class="btn btn-primary btn-xs"
                              title="Adicionar recomendação selecionada"
                              (click)="adicionarSelecionadaNaGrid()"
                              [disabled]="!podeEditar || !form.get('recomendacaoSelecionadaId')?.value">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>

                    <div class="input-group-append">
                      <button type="button"
                              class="btn btn-success btn-nova-recomendacao"
                              (click)="novaRecomendacaoEditor()"
                              [disabled]="!podeEditar">
                        <i class="fas fa-edit"></i> Nova
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Título -->
              <div class="row mt-2">
                <div class="col-sm-12">
                  <label class="form-label">Título:</label>
                  <input type="text"
                         class="form-control form-control-sm"
                         maxlength="150"
                         formControlName="recomendacaoTitulo"
                         [readonly]="!podeEditar || form.get('recomendacaoTitulo')?.disabled" />

                  <small class="text-muted d-block text-right">
                    {{ form.get('recomendacaoTitulo')?.value?.length || 0 }} / 150
                  </small>
                </div>
              </div>

              <!-- Descrição -->
              <div class="row mt-2">
                <div class="col-sm-12">
                  <label class="form-label">Descrição:</label>
                  <textarea class="form-control form-control-sm"
                            rows="4"
                            maxlength="500"
                            formControlName="recomendacaoDescricao"
                            [readonly]="!podeEditar || form.get('recomendacaoDescricao')?.disabled"></textarea>

                  <small class="text-muted d-block text-right">
                    {{ form.get('recomendacaoDescricao')?.value?.length || 0 }} / 500
                  </small>

                  <div
                    *ngIf="modoNovaRecomendacao && form.get('recomendacaoDescricao')?.invalid && form.get('recomendacaoDescricao')?.touched"
                    class="text-danger text-xs mt-1">
                    Campo obrigatório
                  </div>
                </div>
              </div>

              <!-- Botão Adicionar -->
              <div class="row mt-2">
                <div class="col-sm-12 d-flex justify-content-end">
                  <button type="button"
                          class="btn btn-primary btn-sm"
                          (click)="adicionarRecomendacaoDaTela()"
                          [disabled]="!podeEditar || !modoNovaRecomendacao">
                    <i class="fas fa-plus"></i> Adicionar na lista
                  </button>
                </div>
              </div>

              <hr class="my-3" />

              <!-- Grid -->
              <div formArrayName="recomendacoes" class="mat-elevation-z1">
                <div class="table-responsive">
                  <table class="table table-sm table-bordered mb-0" style="table-layout: fixed; width: 100%;"
                         *ngIf="recomendacoes?.length > 0">
                    <thead class="bg-light">
                    <tr>
                      <th style="width:70px;">Nº</th>
                      <th style="width:220px;">Título</th>
                      <th>Descrição</th>
                      <th style="width:120px;" class="text-center">Ações</th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr *ngFor="let rec of recomendacoes.controls; let i = index">
                      <td>{{ i + 1 }}</td>
                      <td style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{ rec.get('titulo')?.value || '-' }}
                      </td>
                      <td style="max-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                        {{ (rec.get('descricao')?.value || '') | slice:0:100 }}
                        <span *ngIf="(rec.get('descricao')?.value || '').length > 100">...</span>
                      </td>
                      <td class="text-center">
                        <button type="button"
                                class="btn btn-info btn-xs mr-1"
                                (click)="visualizarRecomendacao(i)">
                          <i class="far fas fa-eye"></i>
                        </button>

                        <button type="button"
                                class="btn btn-danger btn-xs"
                                (click)="removerRecomendacao(i)"
                                [disabled]="!podeEditar">
                          <i class="far fa-trash-alt"></i>
                        </button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

                <h6 class="table-no-data text-muted text-center p-2" *ngIf="recomendacoes?.length === 0">
                  Nenhuma recomendação adicionada
                </h6>
              </div>

            </div>
          </div>
        </div>
      </div>

    </form>
  </div>

  <!-- ✅ Footer no mesmo padrão -->
  <div class="card-footer">
    <div class="d-flex w-100 justify-content-between align-items-center">
      <div class="list2">
        <button *ngIf="podeFinalizar"
                type="button"
                class="btn btn-warning btn-sm"
                (click)="finalizar()"
                [disabled]="loading">
          <i class="fas fa-check"></i> Finalizar
        </button>

        <!-- Grupo Salvar -->
        <div class="btn-group" *ngIf="podeEditar">
          <button type="button"
                  class="btn btn-primary btn-sm"
                  (click)="salvar()"
                  [disabled]="loading">
            <i class="far fa-save"></i> Salvar
          </button>

          <button type="button"
                  class="btn btn-primary btn-sm dropdown-toggle dropdown-icon"
                  data-toggle="dropdown"
                  aria-expanded="false"
                  [disabled]="loading">
          </button>

          <div class="dropdown-menu dropdown-menu-right" role="menu">
            <a class="dropdown-item" (click)="salvar()">Salvar</a>
            <a class="dropdown-item" (click)="salvar(true)">Salvar e fechar</a>
          </div>
        </div>

        <!-- Fechar -->
        <button type="button"
                class="btn btn-default btn-sm"
                (click)="fecharModal()">
          <i class="fas fa-times"></i> Fechar
        </button>
      </div>
    </div>
  </div>

</div>
